import { Outlet } from 'react-router-dom'

import { NotFound } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useModuleAvailability } from 'modules/core/hooks/useModuleAvailability'

import CollectionsBootstrap from 'modules/trainings/lib/CollectionsBootstrap'

const Container = () => {
  const { company } = useCurrentSession()
  const { loading, moduleAvailability } = useModuleAvailability(
    AvailableModules.trainings,
    company.id
  )

  if (loading) return <></>
  const moduleAvailable = moduleAvailability?.available

  if (!moduleAvailable) return <NotFound title={''} description={''} />

  return <Outlet />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
